import React, { useEffect, useState } from "react";
import Modal from "../../Modal";
import { imageUpload } from "../../../features/slices/liveStream";
import {
  editLectureVideo,
  getLectureVideo,
} from "../../../features/slices/lectureVideoManagement"; // Import your add lecture action here
import { useDispatch } from "react-redux";
import { toastService } from "../../../utils/toastify";
import VideoPlayer from "../../VideoPlayer";

const initialValue = {
  editChapterName: "",
  lessonMedia: [],
  id: "",
  chapterId: "",
};

const EditTopicDetailModal = ({
  setShowEditTopic,
  editTopicData,
  lectureName,
}) => {
  const [iState, setEditState] = useState(initialValue);
  const [errors, setErrors] = useState({});
   console.log({ editTopicData });
  useEffect(() => {
    setEditState((prev) => ({
      ...prev,
      editChapterName: editTopicData?.lectureName,
      lessonMedia: editTopicData?.lessonMedia?.[0],
      id: editTopicData?._id,
      chapterId: editTopicData?.chapterId,
    }));
  }, [editTopicData]);

  const { lessonMedia, editChapterName, chapterId } = iState;
  const dispatch = useDispatch();
  const handleCourseMedia = (field, value) => {
    // Create a shallow copy of lessonMedia array
    setErrors({});
    console.log("dddddd");

    // Copy the specific media object to avoid mutating the original state

    if (field === "video") {
      const file = value;

      if (file) {
        const video = document.createElement("video");
        video.preload = "metadata";
        video.src = URL.createObjectURL(file);
        const formData = new FormData();
        formData.append("fileName", file);

        if (file.type.startsWith("video/")) {
          video.onloadedmetadata = function () {
            URL.revokeObjectURL(video.src);
            const duration = video.duration;
            dispatch(imageUpload(formData)).then((res) => {
              if (res?.payload?.code === 200) {
                // Update the copied media object instead of directly modifying the original
                // updatedMedia[field] = res?.payload?.url;
                // updatedMedia.duration = duration;

                // // Replace the media object in the lessonMedia array
                // updatedCount[index] = updatedMedia;

                // Update the state with the modified lessonMedia array
                setEditState((prev) => ({
                  ...prev,
                  lessonMedia: {
                    ...prev.lessonMedia,
                    duration: duration,
                    video: res?.payload?.url,
                  },
                }));
              }
            });
          };
        }
      }
    } else {
      // For other fields, update the copied media object
      toastService.error("Video upload failed");
    }
  };

  const Updatelectures = () => {
    dispatch(editLectureVideo(iState)).then((data) => {
      if (data?.payload?.code == 200) {
        toastService.success("Video updated successfully");
        dispatch(getLectureVideo({ chapterId }));
        setEditState(initialValue);
        setShowEditTopic(false);
      } else {
        toastService.error("Video update failed");
      }
    });
  };

  const handleChangeEmbeddedVideo = (field, value) => {
    setEditState((prev) => ({
      ...prev,
      lessonMedia: {
        ...prev.lessonMedia,
        video: value,
      },
    }));
  };
  console.log({ lessonMedia, iState });

  return (
    <Modal>
      <div className="modal-body">
        <div className="Category">
          <a className="CloseModal" onClick={() => setShowEditTopic(false)}>
            ×
          </a>
          <h3>Edit Topic Details</h3>
          <div className="form-group">
            <label>Lecture Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Course Name (Auto-fill)"
              value={editChapterName}
              disabled
            />
          </div>

          <div>
            <div className="TitleBox Border">
              <h4 className="Title">Course &amp; Video</h4>
            </div>
            {/* <div className="form-group">
                <label>Language</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Course Name (Auto-fill)"
                  value={res?.language}
                  disabled
                />
              </div> */}
            <div className="form-group">
              <label>Embedded Video</label>
              <input
                type="text"
                className="form-control"
                placeholder="Embedded Video Url"
                onChange={(e) =>
                  handleChangeEmbeddedVideo("video", e.target.value)
                }
                name="embeddedVideo"
                value={lessonMedia?.video}
              />
              {/* {errors.courseMedia.video && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.courseMedia.video}
                </p>
              )} */}
            </div>
            <div className="CommonForm">
              <div
                className="UploadBox Image"
                style={{ position: "relative", zIndex: 0 }}
              >
                <span>
                  {lessonMedia?.video && (
                    <>
                      <VideoPlayer
                        url={lessonMedia?.video}
                        divHeight="110px"
                        setUpdateState={setEditState}
                        divStyle={{
                          height: "100%",
                          position: "absolute",
                          top: "0",
                          left: "0",
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                          zIndex: 1,
                        }}
                      />
                      <i
                        className="fas fa-edit"
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "5px",
                          color: "#fff",
                          background: "rgba(0, 0, 0, 0.6)",
                          borderRadius: "50%",
                          padding: "5px",
                          zIndex: 2,
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          document.querySelector(`#edit-file-input`).click()
                        }
                      />
                    </>
                  )}
                </span>

                <input
                  id={`edit-file-input`}
                  type="file"
                  name="video"
                  accept=".mp4"
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    width: "100%",
                    height: "100%",
                    opacity: 0,
                    zIndex: lessonMedia?.video ? 0 : 2,
                    cursor: "pointer",
                  }}
                  onChange={(e) =>
                    handleCourseMedia("video", e.target.files[0])
                  }
                />
                {!lessonMedia?.video && (
                  <p>
                    <label>Click to upload</label> or <br /> drag &amp; drop
                  </p>
                )}
              </div>
              {errors.lectureVideos && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.lectureVideos}
                </p>
              )}
              {/* {errors[`video${index}`] && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors[`video${index}`]}
                </p>
              )} */}
            </div>
          </div>

          <button className="Button" onClick={Updatelectures}>
            Update
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default EditTopicDetailModal;
